import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class UserAddressVm {
	userId: number;
	addressId: number;
	addressOne?: string;
	addressTwo?: string;
	state?: string;
	city?: string;
	zipCode?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userId': new UntypedFormControl(0, [...(validators['userId'] ?? []), ...[Validators.required]]),
			'addressId': new UntypedFormControl(0, [...(validators['addressId'] ?? []), ...[Validators.required]]),
			'addressOne': new UntypedFormControl(null, [...(validators['addressOne'] ?? []), ...[Validators.maxLength(35)]]),
			'addressTwo': new UntypedFormControl(null, [...(validators['addressTwo'] ?? []), ...[Validators.maxLength(35)]]),
			'state': new UntypedFormControl(null, [...(validators['state'] ?? []), ...[]]),
			'city': new UntypedFormControl(null, [...(validators['city'] ?? []), ...[Validators.maxLength(30)]]),
			'zipCode': new UntypedFormControl(null, [...(validators['zipCode'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): UserAddressVmFromFg {
		return new UserAddressVmFromFg(fg);
	}
}

export class UserAddressVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}

	get addressId(): number {
		return this.fg.get('addressId').value;
	}
	set addressId(val) {
		this.fg.get('addressId').setValue(val);
	}

	get addressOne(): string {
		return this.fg.get('addressOne').value;
	}
	set addressOne(val) {
		this.fg.get('addressOne').setValue(val);
	}

	get addressTwo(): string {
		return this.fg.get('addressTwo').value;
	}
	set addressTwo(val) {
		this.fg.get('addressTwo').setValue(val);
	}

	get state(): string {
		return this.fg.get('state').value;
	}
	set state(val) {
		this.fg.get('state').setValue(val);
	}

	get city(): string {
		return this.fg.get('city').value;
	}
	set city(val) {
		this.fg.get('city').setValue(val);
	}

	get zipCode(): string {
		return this.fg.get('zipCode').value;
	}
	set zipCode(val) {
		this.fg.get('zipCode').setValue(val);
	}
}
